import { Action, createReducer, on } from '@ngrx/store';
import { initialMessageState } from './message.state';
import {
  addStackedMessageFailure,
  addStackedMessageSuccess,
  removeStackedLongMessage,
  removeStackedLongMessagesByType,
  removeMessageByKey,
  removeSegmentMessages,
  removeShortMessage,
  removeShortMessagesByType,
  resetStackedLongMessages,
  resetShortMessages,
  setCurrentStackedLongMessageIndex,
  setCurrentShortMessageIndex,
  addMessage,
  addMessageSuccess,
  addMessageFailure,
  resetLongMessage,
  resetJetStreamMessagesForPassenger,
  addJetStreamMessageComplete,
  addJetStreamShortMessageComplete,
  resetJetStreamShortMessages,
  addGlobalMessage,
  addGlobalMessageFailure,
  addGlobalMessageSuccess,
  setCurrentGlobalMessageIndex,
  removeGlobalMessage,
  addGlobalJetStreamMessageComplete,
  resetJetStreamMessagesForNonFiltered,
  removeGlobalJetStreamMessage,
  removeMessagesByKeys,
  resetCurrentStackedLongMessageIndex,
  resetGlobalJetStreamMessages,
  removeGlobalJetStreamMessageByCategory,
  addMileagePlanMessageSuccess,
  removeMileagePlanMessage,
  removeMileagePlanMessages,
  addCarekitMessageSuccess,
  removeCarekitMessage,
  removeCarekitMessages,
  addCouponMessageSuccess,
  removeCouponMessage,
  removeCouponMessages,
  removeInvoluntaryChangeMessages,
  removeInvoluntaryChangeMessage,
  addInvoluntaryChangeMessageSuccess,
  addManualAssociationMessageSuccess,
  removeManualAssociationMessage,
  removeManualAssociationMessages,
  addPaymentMessageSuccess,
  removePaymentMessage,
  removePaymentMessages,
  addTcpMessageSuccess,
  removeTcpMessage,
  removeTcpMessages,
  addSdcMessageSuccess,
  removeSdcMessage,
  removeSdcMessages,
  addSsrMessageSuccess,
  removeSsrMessage,
  removeSsrMessages,
  addSeatmapMessageSuccess,
  removeSeatmapMessage,
  removeSeatmapMessages,
  addReservationMessageSuccess,
  removeReservationMessage,
  removeReservationMessages,
  removeGlobalMessages,
  removeReservationMessagesByKeys,
  removeJetStreamMessage,
  removeJetStreamMessagesByType,
  addJetStreamMessageNoDuplicatesComplete,
} from './message.actions';
import { MessageStatus } from '../../../models/message/message-status';
import { MessageStyle } from '../../../models/message/message-style';
import { MessageKey } from '../../../models/message/message-key';
import { RichMessage } from '../../../models/message/rich-message';
import { NameNumberUtil } from '../../../utils/name-number-util';

const featureReducer = createReducer(
  initialMessageState,
  on(addGlobalMessage, (state) => ({
    ...state,
    status: MessageStatus.LOADING,
  })),
  on(addMessage, (state) => ({
    ...state,
    status: MessageStatus.LOADING,
  })),
  on(addGlobalMessageSuccess, (state, { message }) => {
    // Remove duplicates
    const concatMessages = [...state.globalMessages.concat(message)];
    const uniqueList = concatMessages.filter((obj, index, self) => {
      return index === self.findIndex((o) => o.emphasisText === obj.emphasisText && o.mainText === obj.mainText);
    });
    // Only add messages if they don't already exist
    state = {
      ...state,
      globalMessages: uniqueList,
      status: MessageStatus.SUCCESS,
    };
    return state;
  }),
  on(addGlobalMessageFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(removeGlobalMessage, (state, { message }) => {
    state = {
      ...state,
      globalMessages: state.globalMessages.filter((msg) => msg.key !== message.key),
    };

    return state;
  }),
  on(removeGlobalMessages, (state) => {
    state = {
      ...state,
      globalMessages: [],
    };

    return state;
  }),

  on(addStackedMessageSuccess, (state, { message }) => {
    switch (message.style) {
      case MessageStyle.LONG:
        state = {
          ...state,
          stackedLongMessages: [...state.stackedLongMessages, message],
          status: MessageStatus.SUCCESS,
        };
        break;
      case MessageStyle.SHORT:
        state = {
          ...state,
          shortMessages: [...state.stackedLongMessages, message],
          status: MessageStatus.SUCCESS,
        };
        break;
      default:
        state = {
          ...state,
          status: MessageStatus.SUCCESS,
        };
    }
    return state;
  }),
  on(addStackedMessageFailure, (state, { error }) => ({
    ...state,
    error,
  })),

  /// Mileage Plan Messages - START
  on(addMileagePlanMessageSuccess, (state, { message }) => {
    state = {
      ...state,
      mileagePlanMessages: [...state.mileagePlanMessages, message],
    };
    return state;
  }),
  on(removeMileagePlanMessage, (state, { message }) => {
    state = {
      ...state,
      mileagePlanMessages: state.mileagePlanMessages.filter((msg) => msg.key !== message.key),
    };

    return state;
  }),
  on(removeMileagePlanMessages, (state) => {
    state = {
      ...state,
      mileagePlanMessages: [],
    };

    return state;
  }),
  /// Mileage Plan Messages - END

  /// Carekit Messages - START
  on(addCarekitMessageSuccess, (state, { message }) => {
    state = {
      ...state,
      carekitMessages: [...state.carekitMessages, message],
    };
    return state;
  }),
  on(removeCarekitMessage, (state, { message }) => {
    state = {
      ...state,
      carekitMessages: state.carekitMessages.filter((msg) => msg.key !== message.key),
    };

    return state;
  }),
  on(removeCarekitMessages, (state) => {
    state = {
      ...state,
      carekitMessages: [],
    };

    return state;
  }),
  /// Carekit Messages - END

  /// Coupon Messages - START
  on(addCouponMessageSuccess, (state, { message }) => {
    state = {
      ...state,
      couponMessages: [...state.couponMessages, message],
    };
    return state;
  }),
  on(removeCouponMessage, (state, { message }) => {
    state = {
      ...state,
      couponMessages: state.couponMessages.filter((msg) => msg.key !== message.key),
    };

    return state;
  }),
  on(removeCouponMessages, (state) => {
    state = {
      ...state,
      couponMessages: [],
    };

    return state;
  }),
  /// Coupon Messages - END

  /// Irrop Messages - START
  on(addInvoluntaryChangeMessageSuccess, (state, { message }) => {
    state = {
      ...state,
      involuntaryChangeMessages: [...state.involuntaryChangeMessages, message],
    };
    return state;
  }),
  on(removeInvoluntaryChangeMessage, (state, { message }) => {
    state = {
      ...state,
      involuntaryChangeMessages: state.involuntaryChangeMessages.filter((msg) => msg.key !== message.key),
    };

    return state;
  }),
  on(removeInvoluntaryChangeMessages, (state) => {
    state = {
      ...state,
      involuntaryChangeMessages: [],
    };

    return state;
  }),
  /// Irrop Messages - END

  /// Manual association messages - START
  on(addManualAssociationMessageSuccess, (state, { message }) => {
    state = {
      ...state,
      manualAssociationMessages: [...state.manualAssociationMessages, message],
    };
    return state;
  }),
  on(removeManualAssociationMessage, (state, { message }) => {
    state = {
      ...state,
      manualAssociationMessages: state.manualAssociationMessages.filter((msg) => msg.key !== message.key),
    };

    return state;
  }),
  on(removeManualAssociationMessages, (state) => {
    state = {
      ...state,
      manualAssociationMessages: [],
    };

    return state;
  }),
  /// Manual association - END

  /// Payment messages - START
  on(addPaymentMessageSuccess, (state, { message }) => {
    state = {
      ...state,
      paymentMessages: [...state.paymentMessages, message],
    };
    return state;
  }),
  on(removePaymentMessage, (state, { message }) => {
    state = {
      ...state,
      paymentMessages: state.paymentMessages.filter((msg) => msg.key !== message.key),
    };

    return state;
  }),
  on(removePaymentMessages, (state) => {
    state = {
      ...state,
      paymentMessages: [],
    };

    return state;
  }),
  /// Payment - END

  /// Tcp Messages - START
  on(addTcpMessageSuccess, (state, { message }) => {
    state = {
      ...state,
      tcpMessages: [...state.tcpMessages, message],
    };
    return state;
  }),
  on(removeTcpMessage, (state, { message }) => {
    state = {
      ...state,
      tcpMessages: state.tcpMessages.filter((msg) => msg.key !== message.key),
    };

    return state;
  }),
  on(removeTcpMessages, (state) => {
    state = {
      ...state,
      tcpMessages: [],
    };

    return state;
  }),
  /// Tcp Messages - END

  /// Sdc Messages - START
  on(addSdcMessageSuccess, (state, { message }) => {
    state = {
      ...state,
      sdcMessages: [...state.sdcMessages, message],
    };
    return state;
  }),
  on(removeSdcMessage, (state, { message }) => {
    state = {
      ...state,
      sdcMessages: state.sdcMessages.filter((msg) => msg.key !== message.key),
    };

    return state;
  }),
  on(removeSdcMessages, (state) => {
    state = {
      ...state,
      sdcMessages: [],
    };

    return state;
  }),
  /// Sdc Messages - END

  /// Ssr Messages - START
  on(addSsrMessageSuccess, (state, { message }) => {
    state = {
      ...state,
      ssrMessages: [...state.ssrMessages, message],
    };
    return state;
  }),
  on(removeSsrMessage, (state, { message }) => {
    state = {
      ...state,
      ssrMessages: state.ssrMessages.filter((msg) => msg.key !== message.key),
    };

    return state;
  }),
  on(removeSsrMessages, (state) => {
    state = {
      ...state,
      ssrMessages: [],
    };

    return state;
  }),
  /// Ssr Messages - END

  /// Seatmap Messages - START
  on(addSeatmapMessageSuccess, (state, { message }) => {
    state = {
      ...state,
      seatmapMessages: [...state.seatmapMessages, message],
    };
    return state;
  }),
  on(removeSeatmapMessage, (state, { message }) => {
    state = {
      ...state,
      seatmapMessages: state.seatmapMessages.filter((msg) => msg.key !== message.key),
    };

    return state;
  }),
  on(removeSeatmapMessages, (state) => {
    state = {
      ...state,
      seatmapMessages: [],
    };

    return state;
  }),
  /// Seatmap Messages - END

  /// Reservation Messages - START
  on(addReservationMessageSuccess, (state, { message }) => {
    state = {
      ...state,
      reservationMessages: [...state.reservationMessages, message],
    };
    return state;
  }),
  on(removeReservationMessage, (state, { message }) => {
    state = {
      ...state,
      reservationMessages: state.reservationMessages.filter((msg) => msg.key !== message.key),
    };

    return state;
  }),
  on(removeReservationMessages, (state) => {
    state = {
      ...state,
      reservationMessages: [],
    };

    return state;
  }),
  /// Reservation Messages - END

  on(addGlobalJetStreamMessageComplete, (state, { messages }) => {
    // Remove duplicates based on key
    const uniqueMessages = removeDuplicatesByKey([...state.globalJetStreamMessages.concat(messages)]);
    state = {
      ...state,
      globalJetStreamMessages: uniqueMessages,
      status: MessageStatus.SUCCESS,
    };
    return state;
  }),
  on(removeGlobalJetStreamMessage, (state, { key }) => {
    state = {
      ...state,
      globalJetStreamMessages: state.globalJetStreamMessages.filter((msg) => msg.key !== key),
      status: MessageStatus.SUCCESS,
    };
    return state;
  }),
  on(removeGlobalJetStreamMessageByCategory, (state, { category }) => {
    state = {
      ...state,
      globalJetStreamMessages: state.globalJetStreamMessages.filter((msg) => !category.includes(msg.category)),
      status: MessageStatus.SUCCESS,
    };
    return state;
  }),
  on(addJetStreamMessageComplete, (state, { messages }) => {
    state = {
      ...state,
      jetStreamMessages: [...state.jetStreamMessages.concat(messages)],
      status: MessageStatus.SUCCESS,
    };
    return state;
  }),
  on(addJetStreamMessageNoDuplicatesComplete, (state, { messages }) => {
    const newMessages = messages.filter((newMsg) => !state.jetStreamMessages.some((existingMsg) => existingMsg.key === newMsg.key));

    state = {
      ...state,
      jetStreamMessages: [...state.jetStreamMessages.concat(newMessages)],
      status: MessageStatus.SUCCESS,
    };
    return state;
  }),
  on(removeJetStreamMessage, (state, { key }) => {
    state = {
      ...state,
      jetStreamMessages: state.jetStreamMessages.filter((msg) => msg.key !== key),
      status: MessageStatus.SUCCESS,
    };
    return state;
  }),
  on(removeJetStreamMessagesByType, (state, { messageType }) => ({
    ...state,
    jetStreamMessages: state.jetStreamMessages.filter((msg) => msg.type !== messageType),
    status: MessageStatus.SUCCESS,
  })),
  on(addJetStreamShortMessageComplete, (state, { messages }) => {
    // Remove duplicates
    const concatMessages = [...state.jetStreamShortMessages.concat(messages)];
    const uniqueList = concatMessages.filter((obj, index, self) => {
      return index === self.findIndex((o) => o.emphasisText === obj.emphasisText && o.mainText === obj.mainText);
    });
    // Only add messages if they don't already exist
    state = {
      ...state,
      jetStreamShortMessages: uniqueList,
      status: MessageStatus.SUCCESS,
    };
    return state;
  }),
  on(addMessageSuccess, (state, { message }) => ({
    ...state,
    longMessage: message,
    status: MessageStatus.SUCCESS,
  })),
  on(addMessageFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(setCurrentGlobalMessageIndex, (state, { index }) => ({
    ...state,
    currentGlobalMessageIndex: index > state.globalMessages.length - 1 ? state.globalMessages.length - 1 : index,
  })),
  on(setCurrentStackedLongMessageIndex, (state, { index }) => ({
    ...state,
    currentLongMessageIndex: index > state.stackedLongMessages.length - 1 ? state.stackedLongMessages.length - 1 : index,
  })),
  on(setCurrentShortMessageIndex, (state, { index }) => ({
    ...state,
    currentShortMessageIndex: index > state.shortMessages.length - 1 ? state.shortMessages.length - 1 : index,
  })),
  on(resetStackedLongMessages, (state) => ({
    ...state,
    stackedLongMessages: [],
    error: null,
    status: MessageStatus.STABLE,
  })),
  on(resetCurrentStackedLongMessageIndex, (state) => ({
    ...state,
    currentLongMessageIndex: 0,
  })),
  on(resetShortMessages, (state) => ({
    ...state,
    shortMessages: [],
  })),
  on(resetLongMessage, (state) => ({
    ...state,
    longMessage: null,
    error: null,
    status: MessageStatus.STABLE,
  })),
  on(resetJetStreamMessagesForPassenger, (state, { passengerId, bypassFilter }) => {
    const updatedMessages = state.jetStreamMessages.filter((msg) => {
      if (
        !bypassFilter &&
        (!msg.passengerId ||
          (msg.passengerId &&
            NameNumberUtil.ToNonZeroPaddedCollapseDecimal(msg.passengerId) !== NameNumberUtil.ToNonZeroPaddedCollapseDecimal(passengerId)))
      ) {
        return true;
      }
      return false;
    });
    return {
      ...state,
      jetStreamMessages: updatedMessages,
    };
  }),
  on(resetJetStreamMessagesForNonFiltered, (state) => {
    const updatedMessages = state.jetStreamMessages.filter((msg) => {
      if (!msg.passengerId) {
        return false;
      }
      return true;
    });
    return {
      ...state,
      jetStreamMessages: updatedMessages,
    };
  }),
  on(resetJetStreamShortMessages, (state) => ({
    ...state,
    jetStreamShortMessages: [],
  })),
  on(resetGlobalJetStreamMessages, (state) => ({
    ...state,
    globalJetStreamMessages: [],
  })),
  on(removeGlobalMessage, (state, { message }) => {
    const messages = state.globalMessages.filter((msg) => msg !== message);
    const currentMessageIndex = state.currentGlobalMessageIndex < messages.length ? state.currentGlobalMessageIndex : 0;
    return {
      ...state,
      globalMessages: messages,
      currentGlobalMessageIndex: currentMessageIndex,
    };
  }),
  on(removeStackedLongMessage, (state, { message }) => {
    const stackedLongMessages = state.stackedLongMessages.filter((msg) => msg !== message);
    const currentLongMessageIndex = state.currentLongMessageIndex < stackedLongMessages.length ? state.currentLongMessageIndex : 0;
    return {
      ...state,
      stackedLongMessages,
      currentLongMessageIndex,
    };
  }),
  on(removeShortMessage, (state, { message }) => {
    const shortMessages = state.shortMessages.filter((msg) => msg !== message);
    const currentShortMessageIndex = state.currentShortMessageIndex < shortMessages.length ? state.currentShortMessageIndex : 0;
    return {
      ...state,
      shortMessages,
      currentShortMessageIndex,
    };
  }),
  on(removeStackedLongMessagesByType, (state, { messageType }) => ({
    ...state,
    stackedLongMessages: state.stackedLongMessages.filter((msg) => msg.type !== messageType),
  })),
  on(removeShortMessagesByType, (state, { messageType }) => ({
    ...state,
    shortMessages: state.shortMessages.filter((msg) => msg.type !== messageType),
  })),
  on(removeMessageByKey, (state, { messageKey, segmentIndex, passengerId }) => {
    return {
      ...state,
      stackedLongMessages: state.stackedLongMessages.filter(
        (message: RichMessage) => !isMatching(message, messageKey, segmentIndex, passengerId)
      ),
    };
  }),
  on(removeMessagesByKeys, (state, { messageKeys, segmentIndex, passengerId }) => {
    messageKeys.forEach((key) => {
      state = {
        ...state,
        stackedLongMessages: state.stackedLongMessages.filter(
          (message: RichMessage) => !isMatching(message, key, segmentIndex, passengerId)
        ),
      };
    });
    return state;
  }),
  on(removeReservationMessagesByKeys, (state, { messageKeys }) => {
    messageKeys.forEach((key) => {
      state = {
        ...state,
        reservationMessages: state.reservationMessages.filter((message: RichMessage) => message.key !== key),
      };
    });
    return state;
  }),
  on(removeSegmentMessages, (state, { segmentIndex }) => {
    return {
      ...state,
      stackedLongMessages: state.stackedLongMessages.filter((message: RichMessage) => message.segmentIndex !== segmentIndex),
    };
  })
);

export function messageReducer(state = initialMessageState, action: Action) {
  return featureReducer(state, action);
}

/**
 * Returns true if this message matches the key, segment and passengerId
 */
function isMatching(message: RichMessage, messageKey: MessageKey, segmentIndex?: number, passengerId?: string): boolean {
  const keyMatch = messageKey === message.key;
  const segmentIndexMatch = segmentIndex === message.segmentIndex;
  const passengerIdMatch = passengerId === message.passengerId;

  return keyMatch && segmentIndexMatch && passengerIdMatch;
}

/**
 * Returns a list of messages without duplicates based on the message key
 */
function removeDuplicatesByKey(messages: RichMessage[]): RichMessage[] {
  return [...new Map(messages.map((msg) => [msg.key, msg])).values()];
}
